import { PPCollectItem, PPOrder } from "../models/PPOrder";
import { httpService } from "@/common/services/HttpService";
import qs from "qs";
import { PPPOrderItem } from "@/picking-portal/models/PPOrderItem";
import { PPOrderStatus } from "@/picking-portal/enums/PPOrderStatus";
import { PPClickAndCollectStatus } from "@/picking-portal/enums/PPClickAndCollectStatus";

class PPOrderService {
  baseUrl = "/api/v1/backoffice/staff/fulfillments";

  async getFulfillment(transactionId: string): Promise<PPOrder> {
    const { data } = await httpService.getInstance().get<PPOrder>(`${this.baseUrl}/${transactionId}`);
    return data;
  }

  async getFulfillments(transactionIds: string[]): Promise<PPOrder[]> {
    const { data } = await httpService.getInstance().get<PPOrder[]>(`${this.baseUrl}`, {
      params: {
        transactionIds: transactionIds,
      },
      paramsSerializer: function (params) {
        return qs.stringify(params, { arrayFormat: "repeat" });
      },
    });
    return data;
  }

  async updateFulfillmentItem(transactionId: string, item: PPCollectItem): Promise<PPOrder> {
    return await httpService
      .getInstance()
      .patch(`${this.baseUrl}/${transactionId}/item`, [item])
      .then((response) => response.data);
  }

  async updateFulfillmentStatus(orderId: number, status: PPOrderStatus): Promise<boolean> {
    await httpService.getInstance().post(`${this.baseUrl}/${orderId}/status`, { status: status });
    return true;
  }

  async setFulfillmentCollected(transactionId: string): Promise<boolean> {
    await httpService.getInstance().post(`${this.baseUrl}/${transactionId}/collected`);
    return true;
  }

  async setFulfillmentItemsPicked(transactionId: string, items: PPCollectItem[]): Promise<void> {
    return await httpService.getInstance().post(`${this.baseUrl}/${transactionId}/picked`, items);
  }

  async updateOrderPicker(transactionId: string, pickerId: string): Promise<PPOrder> {
    const { data } = await httpService
      .getInstance()
      .patch(`${this.baseUrl}/${transactionId}/picker`, { pickerId: pickerId });
    return data;
  }

  async cancelFulfillment(transactionId: string): Promise<PPOrder> {
    const { data } = await httpService.getInstance().delete(`${this.baseUrl}/${transactionId}`);
    return data;
  }

  getRestrictedAgeForOrder(order: PPOrder): number {
    let restrictedAge = 0;
    (order.pickingItems ?? []).forEach((item) => {
      if (item.restrictedAge > restrictedAge) {
        restrictedAge = item.restrictedAge;
      }
    });
    return restrictedAge;
  }
}

export const orderService = new PPOrderService();
